import Api from "../Api";



const getAll = async (dataHoraIni, dataHoraFim, filtros) => {


    let query = []
    if (dataHoraIni != undefined && dataHoraIni != null) {
        query.push('data=' + dataHoraIni)
    }
    if (dataHoraFim != undefined && dataHoraFim != null) {
        query.push('dataFinal=' + dataHoraFim)
    }
    if (filtros?.withAnimaisClientes == true) {
        query.push('withAnimaisClientes=true')
    }
    if (filtros?.withAgendamentosItens == true) {
        query.push('withAgendamentosItens=true')
    }
    if (filtros?.profissionaisId) {
        query.push('profissionaisId=' + filtros?.profissionaisId)
    }
    if (filtros?.clientesId) {
        query.push('clientesId=' + filtros?.clientesId)
    }
    if (filtros?.animaisId) {
        query.push('animaisId=' + filtros?.animaisId)
    }
    if (filtros?.paginate) {
        query.push('paginate=' + filtros?.paginate)
    }
    
    if (filtros?.tiposServicosId) {
        query.push('tiposServicosId=' + filtros?.tiposServicosId)
    }
     if (filtros?.page) {
        query.push('page=' + filtros?.page)
    }
    query = query.join('&')

    try {
        const { data } = await Api.get('/agendamentos?' + query);
        return data;
    } catch (error) {
        console.log(error)
    }



}

const store = async (dados) => {

    try {
        const { data } = await Api.post('/agendamentos', dados);
        return data;
    } catch (error) {
        console.log(error)
    }
}

const update = async (idAgendamento, dados) => {

    try {
        const { data } = await Api.put('/agendamentos/' + idAgendamento, dados);
        return data;
    } catch (error) {
        console.log(error)
    }
}


const deleteById = async (idAgendamento) => {

    try {
        const { data } = await Api.delete('/agendamentos/' + idAgendamento);
        return data;
    } catch (error) {
        console.log(error)
    }
}

const getById = async (idAgendamento) => {

    try {
        const { data } = await Api.get('/agendamentos/' + idAgendamento);
        return data;
    } catch (error) {
        console.log(error)
    }
}



const atualizaDataHora = async (idAgendamento, dados) => {

    try {
        const { data } = await Api.post('/agendamentos/atualizarDataHora/' + idAgendamento, dados);
        return data;
    } catch (error) {
        console.log(error)
    }
}
const getDatasByMes = async (tipoPeriodo, filtros) => {

    let query = []

    query.push('tipoPeriodo=' + tipoPeriodo)

    if (filtros?.mes) {
        query.push('mes=' + filtros?.mes)
    }
    if (filtros?.ano) {
        query.push('ano=' + filtros?.ano)
    }
    if (filtros?.data) {
        query.push('data=' + filtros?.data)
    }
    if (filtros?.dataFinal) {
        query.push('dataFinal=' + filtros?.dataFinal)
    }
    if (filtros?.tiposServicosId) {
        query.push('tiposServicosId=' + filtros?.tiposServicosId)
    }
    if (filtros?.profissionaisId) {
        query.push('profissionaisId=' + filtros?.profissionaisId)
    }
    
    query = query.join('&')
    try {
        const { data } = await Api.get('/agendamentos/getDatasPorMes?'+ query);
        return data;
    } catch (error) {

    }
}

export const AgendamentosService = {
    getAll,
    store,
    update,
    getById,
    deleteById,
    atualizaDataHora,
    getDatasByMes
}